import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { select } from '@ngrx/store';

import { SessionService } from '../../store/services/session.service';
import { filter, map } from 'rxjs/operators';
import { UserType } from '../../store/models/user.model';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
  ) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.sessionService.onReady()
      .pipe(
        filter(session => !!session),
        select(sess => sess.user_type),
        map(userType => {
          return userType === UserType.MASTER ? true : this.router.createUrlTree(['/']);
        }),
      );
  }
}
